import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  standalone: false,
  selector: 'app-patient-portal-request-appointment',
  templateUrl: './patient-portal-request-appointment.component.html',
  styleUrls: ['./patient-portal-request-appointment.component.css']
})
export class PatientPortalRequestAppointmentComponent implements OnInit {

  reasonText: string;

  constructor(
    public dialogRef: MatDialogRef<PatientPortalRequestAppointmentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {

    console.log(this.data);

  }

  close(proceed) {
    if (!proceed)
      this.reasonText = '';
    this.dialogRef.close(this.reasonText);
  }

}
